import React from "react";
import style from "../../assets/css/global-fields.module.scss";
import fillCircle from "../../assets/img/proposal-img/checkbox-fill.svg";
import emptyCircle from "../../assets/img/proposal-img/checkbox-empty.svg";
import {useState} from "react";
import GlobalErrorMsgBox from "./GlobalErrorMsgBox";

const GlobalCheckBox = ({title, selected, onClick, error, errorText}) => {
  return (
    <div className={style.GlobalCheckBoxBtn}>
      <button
        className={`${style.global_radio} ${selected ? style.globalRadioActive : null}`}
        onClick={onClick}
      >
        {selected ? (
          <img alt="fillcrcl" src={fillCircle} />
        ) : (
          <img alt="emptcrcl" src={emptyCircle} />
        )}
        {title}
      </button>
      {error ? <GlobalErrorMsgBox errMessage={errorText} /> : null}
    </div>
  );
};

export default GlobalCheckBox;
